import { render, staticRenderFns } from "./contentBoard.vue?vue&type=template&id=176ed7e2&scoped=true&"
import script from "./contentBoard.vue?vue&type=script&lang=js&"
export * from "./contentBoard.vue?vue&type=script&lang=js&"
import style0 from "./contentBoard.vue?vue&type=style&index=0&id=176ed7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176ed7e2",
  null
  
)

export default component.exports